import { DeliveryArea } from './types';

export const isSameDeliveryArea = (a: DeliveryArea, b: DeliveryArea): boolean =>
  a.postalCode === b.postalCode && a.city === b.city
